import React from "react";
import AddonsCad from "../component/addonsCad";
import Logo from "assets/images/png/gray.jpg";
import ActivationFile from "../component/activationFile";
import { useModal } from "hooks";
import { useProductsAddon } from "hooks/use-products";
import { useParams } from "react-router-dom";
import NoData from "components/noData/noData";
import { Spinner } from "react-bootstrap";
const Addons = () => {
  //const [showActivationFile, openActivationFile, closeActivationFile] = useModal(false);
  const { id } = useParams();
  const { productsAddon, isError, isSuccess, isLoading } = useProductsAddon(id);

  return (
    <div className="page-addons">
      <div className="row">
      {isLoading && (
          <div className="my-center">
            <Spinner animation="grow" variant="primary" />
          </div>
        )}
        {isSuccess &&   (
          productsAddon?.map((addon) => (
            <div className="col-xl-2 col-lg-3 col-md-6 col-md-6" key={addon?.addOnId}>
              <AddonsCad
                addon={addon}
              />
            </div>
          ))
          )
        }
        {
            productsAddon.length <= 0 && (
                <div className="col-12">
                <NoData   packages={"products"}/>
              </div>
            )
        }
        
      </div>
    </div>
  );
};

export default Addons;
